








import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Vue slide transition
 */
@Component
export default class TransitionSlide extends Vue {}
